var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"upload-file"},[_c('dropzone',{attrs:{"id":"file-dropzone","options":_vm.options},on:{"vdropzone-sending":_vm.UploadFile,"vdropzone-complete":_vm.HandleResponse}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }